import { styled } from '@/stitches.config';

import { ReactComponent as SuccessIconWithdrawal } from '@assets/icons/success-icon.svg';

import { Box, Paragraph } from '@components';

export const StyledParagraph = styled(Paragraph, {
  fontWeight: '$bold',
  margin: '$4 $0',
});

export const StyledSuccessPageContainer = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
});

export const StyledAlternativeContainer = styled(Box, {
  color: '$charcoal300',
  display: 'flex',
  flexDirection: 'column',
  fontSize: '$sm',
  fontWeight: '300',
  lineHeight: '$4',
  marginBottom: '$5',
  maxWidth: '513px',
});

export const StyledMessageContainer = styled(Box, {
  color: '$charcoal300',
  display: 'flex',
  flexDirection: 'column',
  fontSize: '$sm',
  fontWeight: '300',
  lineHeight: '$4',
  marginBottom: '$3',
  maxWidth: '513px',
});

export const StyledSubmitted = styled(Box, {
  color: '#3F4C77',
  fontSize: '$xl',
  fontWeight: '$bold',
  lineHeight: '$8',
  marginBottom: '$3',
});

export const StyledButtonContent = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: '$2',
});

export const StyledHandledReset = styled(Box, {
  color: '$blue300',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  fontSize: '$sm',
  fontWeight: '$medium',
  lineHeight: '$4',
  margin: '$2 0 $3 0',
});

export const StyledSuccessIconWithdrawal = styled(SuccessIconWithdrawal, {});

export const StyledExternalLink = styled('a', {
  $$link: '$colors$blue300',
  $$linkActive: '$colors$blue200',

  // Custom styles matching Link component
  color: '$$link',
  fontWeight: '$medium',
  px: '$0',
  py: '$0',
  textDecoration: 'none',
  fontSize: '$sm', // default small size
  '&:hover': {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  '&:active': {
    color: '$$linkActive',
  },
});
